<template>
  <VBtn
    color="primary"
    class="button-medium"
    variant="outlined"
    size="medium"
    prepend-icon="filter_list"
    data-testid="btn-activator"
    @click.prevent
  >
    {{ t('Filters') }}
    <ConsultationFilterDialog />
  </VBtn>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ConsultationFilterDialog from './ConsultationFilterDialog.vue'

const { t } = useI18n()
</script>
